/**
 * Descrição curta de cada tela e de cada módulo do menu, usada nos cards de
 * permissão do cadastro de Perfil de Usuário. Os textos ficam aqui (e não no
 * menu) para não pesar a navegação, e são traduzidos pelo dicionário interno
 * em `i18n/IdiomaProvider.tsx`.
 */

/** Descrição curta por rota do menu (mesma chave usada em `iconesMenu.ts`). */
export const DESCRICAO_POR_ROTA: Record<string, string> = {
  "/": "Painel inicial com os indicadores do sistema.",
  "/protocolo": "Protocolos de retirada e recebimento de itens, com assinatura.",
  "/bloco-notas": "Anotações pessoais do login.",

  "/cadastros/empresas": "Dados cadastrais das empresas.",
  "/cadastros/bancos": "Bancos e contas utilizados.",
  "/cadastros/clientes": "Cadastro da carteira de clientes.",
  "/cadastros/fornecedores": "Cadastro de fornecedores da empresa.",
  "/cadastros/transportadoras": "Transportadoras usadas nas entregas.",
  "/cadastros/colaboradores": "Equipe e dados dos colaboradores.",
  "/cadastros/produtos": "Catálogo de produtos da empresa.",
  "/cadastros/detalhes": "Tabela de preços dos produtos vinculada às Faixas de Preço.",
  "/cadastros/tabela-detalhes": "Cadastro das tabelas de detalhes.",
  "/cadastros/faixas-preco": "Faixas de preço por valor ou intervalo de quantidade.",
  "/cadastros/servicos": "Catálogo de serviços prestados.",
  "/cadastros/unidades-medida": "Unidades usadas nos produtos.",
  "/cadastros/categorias-estoque": "Categorias de produtos e estoque.",
  "/cadastros/detalhes-ficha": "Itens editáveis usados na composição das fichas.",
  "/cadastros/oficinas": "Cadastro das oficinas e seus responsáveis.",
  "/cadastros/etapas": "Etapas de trabalho e seus respons\u00e1veis.",
  "/cadastros/locais-estoque": "Locais de armazenamento do estoque.",
  "/cadastros/tamanhos": "Grade de tamanhos dos produtos.",
  "/cadastros/cores": "Cores da grade de produtos.",
  "/cadastros/etiquetas": "Etiquetas para classificar conversas e registros.",
  "/cadastros/respostas-rapidas": "Mensagens prontas usadas no atendimento.",
  "/financeiro/plano-contas": "Estrutura de receitas e despesas.",
  "/financeiro/maquininhas": "Maquininhas de cartão e taxas.",
  "/cadastros/erros": "Códigos de erro do sistema.",
  "/cadastros/seriais": "Controle de números de série.",
  "/cadastros/metas": "Regras de remuneração da produção por etapa e responsável.",
  "/usuarios/perfis": "Perfis de acesso e permissões.",
  "/usuarios/logins": "Logins de acesso dos usuários.",


  "/vendas/visao-geral": "Resumo do módulo de vendas.",
  "/vendas": "Registro e consulta de vendas.",
  "/vendas/cobrancas": "Parcelas em aberto e histórico de cobranças das vendas.",
  "/vendas/ficha-tecnica": "Consulta e gerenciamento das fichas técnicas de vendas.",
  "/vendas/pedidos": "Pedidos de venda em andamento.",
  "/area-cliente/pedidos": "Pedidos vinculados ao cadastro de cada cliente.",
  "/area-cliente/chamados": "Chamados abertos pelos clientes.",
  "/area-cliente/chat": "Conversas da Área do Cliente.",
  "/area-cliente/relatorios": "Relatórios de pedidos e chamados dos clientes.",
  "/vendas/entregas": "Controle das entregas de vendas.",
  "/vendas/monitor-fiscal": "Monitor de documentos, contingência e eventos fiscais.",
  "/vendas/nfes-recebidas": "Consulta e manifestação das NF-e emitidas contra a empresa.",
  "/vendas/avaliacoes-atendimento": "Notas e comentários enviados pelos clientes após os atendimentos de vendas.",
  "/vendas/relatorios": "Relatórios específicos do módulo de vendas.",

  "/compras/visao-geral": "Resumo do módulo de compras.",
  "/compras": "Pedidos de compra a fornecedores.",
  "/compras/gantt": "Linha do tempo da venda, formatação, revenda, nota fiscal, distribuição e entrega.",
  "/compras/saldo-compras": "Caixa interno das operações de compras, separado do Financeiro e das Vendas.",
  "/compras/comprovantes-pagamentos": "Consulta dos comprovantes enviados pela empresa ativa às destinatárias, com status e anexos.",
  "/compras/fornecedores": "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.",
  "/compras/ordem-entrega": "Pedidos aprovados com os dados de entrega para a empresa de destino.",
  "/compras/relatorios": "Relatórios específicos do módulo de compras.",

  "/fornecedor/visao-geral": "Resumo dos pedidos recebidos pelo fornecedor.",
  "/fornecedor/pedidos": "Pedidos de compra originados pelas vendas.",
  "/fornecedor/cobrancas": "Consulta das parcelas e vencimentos dos pedidos recebidos pela revenda.",
  "/fornecedor/saldo-interno": "Entradas, pagamentos e parcelas da conta da empresa remetente selecionada.",
  "/fornecedor/entregas": "Pedidos expedidos com nota fiscal e destino.",
  "/fornecedor/envio-nota-fiscal": "Tela de envio de nota fiscal da revenda, aguardando configuração.",
  "/fornecedor/distribuicao": "Tela de distribuição da revenda, aguardando configuração.",
  "/fornecedor/comprovantes-pagamentos": "Consulta dos comprovantes de pagamentos vinculados ao fornecedor.",
  "/fornecedor/relatorios": "Relatórios dos pedidos atendidos pelo fornecedor.",

  "/estoque/visao-geral": "Resumo do módulo de estoque.",
  "/estoque/saldo": "Saldo atual dos produtos.",
  "/estoque/movimentacoes": "Entradas e saídas do estoque.",
  "/estoque/transferencias": "Transferências entre locais com aprovação e rastreabilidade.",
  "/estoque/inventario-ajuste-estoque": "Inventário e ajustes de estoque.",
  "/estoque/relatorios": "Relatórios específicos do módulo de estoque.",

  "/financeiro/visao-geral": "Resumo do módulo financeiro.",
  "/financeiro/receitas": "Gestão dos recebíveis da empresa.",
  "/financeiro/vendas-parceladas": "Controle de vendas parceladas.",
  "/financeiro/despesas": "Gestão dos pagamentos da empresa.",
  "/financeiro/comissoes": "Comissões da produção, pagamentos e anexos por responsável.",
  "/financeiro/fluxo-caixa-diario-mensal": "Controle de entradas e saídas.",
  "/financeiro/dre-gerencial-comercial": "Demonstração do resultado do exercício.",
  "/financeiro/previsibilidade": "Previsão de contas a receber e a pagar dos próximos meses.",
  "/financeiro/relatorios": "Relatórios específicos do módulo financeiro.",

  "/suporte/visao-geral": "Resumo do módulo de suporte.",
  "/suporte": "Chamados abertos pelos clientes.",
  "/suporte/kanban": "Quadro visual dos chamados.",
  "/suporte/calendario": "Agenda de atendimentos e visitas.",
  "/suporte/chat": "Conversas com clientes em tempo real.",
  "/suporte/ativacoes": "Códigos de ativação das vendas parceladas e em Pix; envio liberado após o pagamento.",
  "/suporte/externo": "Atendimentos realizados fora da empresa.",
  "/suporte/orcamentos": "Orçamentos de serviços externos, deslocamento e despesas da visita.",
  "/suporte/avaliacoes-atendimento": "Notas e comentários enviados pelos clientes após os atendimentos de tickets.",
  "/producao/visao-geral": "Indicadores do módulo de produção.",
  "/producao/formatacao": "Formatação dos itens em produção.",
  "/producao/lista": "Listagem das etapas e dos cartões em produção.",
  "/producao/controle": "Acompanhamento da produção dos atendimentos.",
  "/producao/kanban": "Quadro visual das etapas da produção.",
  "/producao/calendario": "Agenda das formatações por data.",
  "/producao/gantt": "Linha do tempo das formatações e das etapas, por status e responsável.",
  "/producao/oficinas": "Gestão das oficinas vinculadas aos atendimentos.",
  "/producao/estoque": "Produção enviada ao estoque, com data e responsável.",
  "/producao/impressoes-dtf": "Impressões DTF concluídas e metragem geral registrada por dia.",
  "/producao/vendas-dtf": "Conversas comerciais recebidas pelo WhatsApp de produção.",
  "/producao/comprovantes-dtf": "Conferência dos comprovantes de pagamentos das vendas marcadas como Serviços.",
  "/producao/avarias": "Avarias, defeitos e erros registrados nas etapas da produção.",
  "/producao/comissoes": "Comissões mensais calculadas pela produção líquida de cada etapa.",
  "/producao/expedicao": "Saídas das formatações, responsáveis e comprovantes de retirada.",
  "/producao/checklists": "Checklists executados e vinculados às formatações na etapa de conferência.",
  "/producao/avaliacoes-atendimento": "Notas e comentários enviados pelos clientes após os atendimentos de produção.",
  "/producao/relatorios": "Relatórios específicos do módulo de produção.",
  "/suporte/relatorios": "Relatórios específicos do módulo de tickets.",

  "/auditoria/log-acesso": "Histórico de acessos ao sistema.",

  "/plataforma/chat-interno": "Conversas individuais e de grupo entre os usuários.",
  "/plataforma/agente": "Assistente de IA disponível no cabeçalho da plataforma.",
  "/plataforma/chat": "Conversas internas entre os usuários da equipe.",
  "/plataforma/central-notificacoes": "Avisos e atividades exibidos no sino do cabeçalho.",
  "/plataforma/notificacoes": "Preferências pessoais de canais e tipos de notificações.",
  "/plataforma/minha-conta": "Consulta dos dados e créditos da conta.",
  "/ajuda": "Orientações e informações para usar a plataforma.",
};

/** Descrição curta por módulo (título do grupo no menu). */
export const DESCRICAO_POR_MODULO: Record<string, string> = {
  "Visão Geral": "Gerencie o acesso ao painel inicial.",
  Cadastros: "Gerencie acessos do módulo de cadastros.",
  Clientes: "Gerencie acessos do módulo de clientes.",
  Vendas: "Gerencie acessos do módulo de vendas.",
  "Área do Cliente": "Gerencie pedidos, chamados, conversas e relatórios dos clientes.",
  Compras: "Gerencie acessos do módulo de compras.",
  Fornecedor: "Gerencie acessos do módulo do fornecedor.",
  Estoque: "Gerencie acessos do módulo de estoque.",
  Financeiro: "Gerencie acessos do módulo financeiro.",
  Suporte: "Gerencie acessos do módulo de suporte.",
  "Produção": "Gerencie acessos do módulo de produção.",
  Auditoria: "Gerencie acessos do módulo de auditoria.",
  Plataforma: "Gerencie acessos das telas gerais da plataforma.",
};

function normalizarRota(rota: string): string {
  if (rota === "/") return rota;
  return rota.replace(/\/+$/, "");
}

/** Descrição da tela; string vazia quando a rota ainda não tem texto cadastrado. */
export function obterDescricaoTelaPorRota(rota: string): string {
  return DESCRICAO_POR_ROTA[normalizarRota(rota)] ?? "";
}

/** Descrição do módulo; texto genérico quando o grupo ainda não tem texto cadastrado. */
export function obterDescricaoModulo(titulo: string): string {
  return DESCRICAO_POR_MODULO[titulo] ?? "Gerencie os acessos deste módulo.";
}
